const CURRENCY_FORMATTER = new Intl.NumberFormat("en-KE", {
  currency: "KSH",
  style: "currency",
});

export function formatCurrency(number: number) {
  return CURRENCY_FORMATTER.format(number).replace(/\s/g, "\u00A0");
}

/** Like formatCurrency, but renders reductions (discounts, credits) as "−KES 50". */
export function formatSignedCurrency(number: number) {
  return number < 0 ? `−${formatCurrency(-number)}` : formatCurrency(number);
}
